<template></template>

<script>
  import 'jquery-validation'
  import 'jquery-validation/dist/additional-methods.js'
  
  export default {
    name: 'RegisterAffiliation',
    mounted () {
      const $form = $('.form')
      
      /**
       * Init Select2 for countries
       */
      const countries = $('.search-country')
      
      countries.select2({
        language: {
          noResults: function () {
            return 'Aún no ha ingresado ningún valor'
          },
        },
      })
      
      /**
       * Init JQuery validation
       */
      $(() => {
        $form.validate({
          ignore: [],
          highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid')
          },
          unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid')
          },
          errorPlacement: function (label, element) {
            if (element.hasClass('select2-input')) {
              label.insertAfter(element.siblings('span.select2'))
            }
            else if (element.is(':radio')) {
              label.insertAfter($('[data-name=\'' + element.attr('name') + '\']'))
            }
            else {
              label.insertAfter(element)
            }
            
            label.addClass('invalid-feedback')
          },
          rules: {
            affiliation_id: {
              required: true,
            },
            member_since: {
              required: true,
            },
            member_until: {
              required: function() {
                return parseInt($('input[name="is_active"]:checked').val()) !==  1
              },
            },
            description: {
              required: true,
            },
            country_id: {
              required: true,
            },
            is_active: {
              required: true,
            },
          },
          messages: {
            affiliation_id: {
              required: 'Este campo es requerido.',
            },
            member_since: {
              required: 'Este campo es requerido.',
            },
            member_until: {
              required: 'Este campo es requerido.',
            },
            description: {
              required: 'Este campo es requerido.',
            },
            country_id: {
              required: 'Este campo es requerido.',
            },
            is_active: {
              required: 'Este campo es requerido.',
            },
          },
          submitHandler (form) {
            $('#btn-save, #btn-cancel').prop('disabled', true)
            $('#btn-save').find('.spinner-border').removeClass('d-none')
            
            form.submit()
          },
        })
        
        $form.removeClass('invisible')

        $('#btn-cancel').on('click', (e) => {
          e.preventDefault()

          history.back()
        })
      })
    },
  }
</script>
